module.exports = __webpack_public_path__ + "img/rtl2_indochine.3dcd0d4a.jpg";